/**
 * Given a SimpleTemplateField type, this hook will extract the field's
 * validations.
 */
import { useMemo } from 'react'

import {
  isValueSetupFieldValue,
  type TemplateField,
} from '../../types/templateModel'

export const useFieldValidations = (field: TemplateField) =>
  useMemo(
    () => (isValueSetupFieldValue(field.value) ? field.value.validations : []),
    [field],
  )
